import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { getAssetBuilder } from '../../REST/assets';

export default function MasterAssetList() {
  const navigate = useNavigate();
  const [assetsList, setAssetsList] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const resp = await getAssetBuilder();
        setAssetsList(resp?.data || []);
      } catch (err) {
        setError('Failed to load assets. Please try again later.');
      }
    })();
  }, []);

  if (error) {
    return (
      <Typography variant="body1" color="error" sx={{ textAlign: 'center' }}>
        {error}
      </Typography>
    );
  }

  if (assetsList.length === 0) {
    return (
      <Typography variant="body1" sx={{ textAlign: 'center' }}>
        No Master Asset added yet. Please click <Link to="/settings/asset">here</Link> to proceed.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          lg: 'repeat(4, minmax(0, 1fr))',
        },
        gap: 2,
      }}
    >
      {assetsList.map((item, index) => (
        <Box
          key={item?._id ?? index}
          id="each-form"
          onClick={() => navigate(`assetList/${item?._id}`)}
          sx={{ cursor: 'pointer' }}
          title={item?.name || 'Unnamed Asset'}
        >
          <Box className="bg-light rounded">
            <Typography component="h5" noWrap title={item?.name || 'Unnamed Asset'}>
              {item?.name || 'Unnamed Asset'}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
